export default __webpack_public_path__ + "static/media/logo_ES.1f4aca28.svg";